/** Semantic view state only: drafts, payment amounts, and commands never enter this bridge. */
export interface ProviderWorkingLocation {
  destination: "dashboard" | "floor" | "schedule" | "register" | "customers" | "venue_setup" | "business";
  context?: { kind: "venue"; venue_id: string } | { kind: "booking" | "session" | "food-order"; venue_id: string; record_id: string };
}
export const PROVIDER_WORKING_LOCATION_EVENT = "gaamed:working-location";
export function reportProviderWorkingLocation(location: ProviderWorkingLocation) {
  window.dispatchEvent(new CustomEvent(PROVIDER_WORKING_LOCATION_EVENT, { detail: location }));
}
export function postProviderWorkingLocation(user: { id: string; role: string }, location: ProviderWorkingLocation) {
  const bridge = (window as Window & { ReactNativeWebView?: { postMessage(data: string): void } }).ReactNativeWebView;
  bridge?.postMessage(JSON.stringify({ type: "gaamed.provider-location.v1", userId: user.id, role: user.role, location }));
}
export function signalProviderWorkspaceSignOut() {
  (window as Window & { ReactNativeWebView?: { postMessage(data: string): void } }).ReactNativeWebView?.postMessage('{"type":"gaamed.provider-signout.v1"}');
}
